// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T524J{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.D6Lg6{color:#747c7f;height:37px;margin-right:14px;width:34px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `T524J`,
	"icon": `D6Lg6`
};
module.exports = ___CSS_LOADER_EXPORT___;
